import React from 'react';
import { Grid, Typography } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import {useStyles} from './styles';
import Card64Image from '../../card64Image';
import Card64Pdf from '../../cardBase64Pdf';
import './style.css'
import { Folder, Visibility } from '@mui/icons-material';
export default function FormInputArchivos(props) {
    const classes = useStyles(props);
    const pdfPreviewSource = props.previewValue || props.value;

    return (
        <>
            {props?.showInputFile && (
                <Grid className={classes.rootFileWithWidth} >
                    <Grid className={"box_img_base"} >
                        {props.fileType === 'pdf' ? (
                            <Card64Pdf label={props.label} pdf={pdfPreviewSource} title={props.name} showDownloadButton={false} src={props.src} showTitle={false} showInMovil={props.showInMovil} />
                        ) : (
                            <Card64Image label={props.label} image={props.value} title={props.name}  src={props.src} showTitle={false} showInMovil={props.showInMovil} showButtonEditDocument={props.showButtonEditDocument} firstTitle={props.firstTitle} iconButton={props.iconButton} />
                        )}
                    </Grid>
                    {props?.nameOfFile && ( <Typography className={classes.nameOfFile}>{props?.nameOfFile || ""}</Typography> )}
                    {!props.disabled && (
                        <label htmlFor={props.name} className="input-file__btn"> <Folder fontSize="small" className={classes.contenedorIcon} />Examinar...</label>
                    )}
                    {props.disabledVisualization && (
                        <label className="input-file__btn" onClick={() => props.handleVisualization(props)} > <Visibility fontSize="small" className={classes.contenedorIcon} />Visualizar...</label>
                    )}
                    <input
                        name={props.name}
                        multiple={props.multiple}
                        className={"input-file-input"}
                        type={props.type}
                        accept={props.accept}
                        onChange={props.handleChangeFile}
                        id={props.name}
                    />
                    {(props.isError) ? <FormHelperText className={classes.errorMessagesFile} id="component-error-text">{props.errorMessages}</FormHelperText> : null }
                </Grid>
            )}
        </>
    )
}

FormInputArchivos.defaultProps = {
    showInputFile: true,
    disabledVisualization: false,
    fileType : 'pdf',
    disabled : false,
}